import React from "react";
import InvoiceField from "../component/InvoiceFiled";

const DeliveryForm = ({ data = {}, onUpdate = () => {}, onSave = () => {} }) => {

  const updateItem = (index, key, value) => {
    const rows = [...(data.items || [])];
    rows[index] = { ...rows[index], [key]: value };
    onUpdate("items", rows);
  };

  const addItem = () => {
    const rows = [
      ...(data.items || []),
      { desc: "", qty: "", unit: "", rate: "", amount: "" }
    ];
    onUpdate("items", rows);
  };

  const removeItem = (index) => {
    const rows = [...(data.items || [])];
    rows.splice(index, 1);
    onUpdate("items", rows);
  };

  const handleSave = () => {
    onSave(data);
  };

  return (
    <div className="space-y-6">

      {/* ================= HEADER ================= */}
      <h3 className="font-bold text-lg text-[#2563EB] border-b pb-2 uppercase tracking-wide">
        Delivery Information
      </h3>

      {/* ================= BASIC INFO ================= */}
      <div className="grid grid-cols-2 gap-4">
        <InvoiceField
          label="Invoice # *"
          value={data?.invoiceNumber || ""}
          onChange={(v) => onUpdate("invoiceNumber", v)}
          required
        />
        <InvoiceField
          label="Due Date"
          type="date"
          value={data?.dueDate || ""}
          onChange={(v) => onUpdate("dueDate", v)}
        />
      </div>

      <InvoiceField
        label="Delivery Driver / Agent"
        value={data?.driverName || ""}
        onChange={(v) => onUpdate("driverName", v)}
      />

      {/* ================= ADDRESS ================= */}
      <div className="pt-4 border-t">
        <h4 className="text-xs font-bold text-gray-400 mb-3 uppercase">
          Address Details
        </h4>

        <InvoiceField
          label="Delivery Destination *"
          type="description"
          value={data?.clientAddress || ""}
          onChange={(v) => onUpdate("clientAddress", v)}
          rows="3"
          required
        />
      </div>

      {/* ================= TAX / PAYMENT ================= */}
      <div className="grid grid-cols-2 gap-4">
        <InvoiceField
          label="Sales Tax (%)"
          type="number"
          value={data?.salesTaxRate || "5"}
          onChange={(v) => onUpdate("salesTaxRate", v)}
        />
        <InvoiceField
          label="Payment Status"
          type="dropdown"
          value={data?.terms || "Due on Receipt"}
          options={["Due on Receipt", "Paid", "COD"]}
          onChange={(v) => onUpdate("terms", v)}
        />
      </div>

      {/* ================= DELIVERY ITEMS ================= */}
      <div className="border-t pt-4">
        <h4 className="text-sm font-bold text-gray-500 mb-2 uppercase">
          Delivery Items
        </h4>

        {(data.items || []).map((item, index) => (
          <div key={index} className="grid grid-cols-5 gap-2 mb-2 items-end">
            <InvoiceField
              label="Description *"
              value={item.desc || ""}
              onChange={(v) => updateItem(index, "desc", v)}
              required
            />
            <InvoiceField
              label="Qty *"
              type="number"
              value={item.qty || ""}
              onChange={(v) => updateItem(index, "qty", v)}
              required
            />
            <InvoiceField
              label="Unit"
              value={item.unit || ""}
              onChange={(v) => updateItem(index, "unit", v)}
            />
            <InvoiceField
              label="Rate (₹) *"
              type="number"
              value={item.rate || ""}
              onChange={(v) => updateItem(index, "rate", v)}
              required
            />
            <InvoiceField
              label="Amount (₹)"
              type="number"
              value={item.amount || ""}
              onChange={() => {}}
              disabled
            />

            <button
              type="button"
              onClick={() => removeItem(index)}
              className="text-red-500 text-xs"
            >
              Remove
            </button>
          </div>
        ))}

        <button
          type="button"
          onClick={addItem}
          className="text-[#2563EB] text-sm mt-2"
        >
          + Add Delivery Item
        </button>
      </div>

      {/* ================= SAVE ================= */}
      <div className="flex justify-end pt-4 border-t">
        <button
          type="button"
          onClick={handleSave}
          className="bg-[#2563EB] text-white px-6 py-2 rounded-md hover:opacity-90"
        >
          Save Delivery Invoice
        </button>
      </div>

    </div>
  );
};

export default DeliveryForm;
